import { TILE_SHAPES } from '@mixtiles/web-backend-shared'
import { getShapeFromSize } from 'services/ShapeManager'
import { type SinglePhotoTileStore } from 'stores/tilesStore/tiles/SinglePhotoTileStore'
import {
  DEFAULT_THUMB_CROP,
  type ThumbCrop,
  type TilesThumbData,
} from '../../CartItem'

function isSquareTile(tile: SinglePhotoTileStore): boolean {
  return getShapeFromSize(tile.tileSize) === TILE_SHAPES.SQUARE
}

export function selectMainPhotoTile(
  photoTiles: SinglePhotoTileStore[]
): SinglePhotoTileStore | undefined {
  return photoTiles.find(isSquareTile) ?? photoTiles[0]
}

export function selectBackgroundPhotoTile(
  mainPhotoTile: SinglePhotoTileStore,
  otherPhotoTiles: SinglePhotoTileStore[]
): SinglePhotoTileStore | null {
  if (otherPhotoTiles.length === 0) return null

  const hasDifferentFrameColor = (tile: SinglePhotoTileStore) =>
    tile.frameColor !== mainPhotoTile.frameColor

  return (
    otherPhotoTiles.find(
      (tile) => isSquareTile(tile) && hasDifferentFrameColor(tile)
    ) ??
    otherPhotoTiles.find(hasDifferentFrameColor) ??
    otherPhotoTiles.find(isSquareTile) ??
    otherPhotoTiles[0]
  )
}

function tileToRelativeCrop(tile: SinglePhotoTileStore): ThumbCrop {
  const crop = tile.cropParams[tile.currentAspectRatio]
  if (!crop?.width || !crop?.height || !tile.width || !tile.height) {
    return DEFAULT_THUMB_CROP
  }
  return {
    xRatio: (crop.x ?? 0) / tile.width,
    yRatio: (crop.y ?? 0) / tile.height,
    widthRatio: crop.width / tile.width,
    heightRatio: crop.height / tile.height,
  }
}

export function tileToThumbData(tile: SinglePhotoTileStore): TilesThumbData {
  return {
    thumbUrl: tile.photo?.minimalResUrl ?? null,
    crop: tileToRelativeCrop(tile),
    filterImageUrl: tile.filterImageUrl ?? undefined,
    materialType: tile.materialType,
    frameColor: tile.frameColor,
    matting: tile.matting,
    tileSize: tile.tileSize,
    filter: tile.filter,
    mattingColor: tile.mattingColor,
  }
}
